import { Breakpoints } from '@doordash/design-language';

/**
 * Breakpoints limits. For a given breakpoint we generate URI's that target the maximum
 * extend of the breakpoint e.g. 480 for mobile. Currently web uses a content column that is never
 * wider than 800 so extending this for images larger than the largest breakpoint is not necessary.
 *
 * WideScreen: 1184,
 * Desktop: 960,
 * Tablet: 768,
 * Mobile: 480
 *
 */

var BREAKPOINTS = [Breakpoints.Mobile, Breakpoints.Tablet, Breakpoints.Desktop, Breakpoints.WideScreen];
/**
 * Certain properties must be specified per breakpoint. This type is used to represent those properties
 * Current viewportPercentages and fixedWidths use this type.
 */

export { BREAKPOINTS };
